var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewfeedbackWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5584 8.42857V5.1985C12.5584 4.73047 12.3725 4.28161 12.0416 3.95066L10.6078 2.51687C10.2768 2.18592 9.82797 2 9.35994 2H2.76471C1.79008 2 1 2.79009 1 3.76471V15.2353C1 16.2099 1.79009 17 2.76471 17H10.7937C11.7684 17 12.5584 16.2099 12.5584 15.2353V14.5325",
    stroke: "white",
    strokeWidth: 0.882353,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5778 5.30827H11.3129C10.1844 5.30827 9.26953 4.39343 9.26953 3.26493V2",
    stroke: "white",
    strokeWidth: 0.882353
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.48047 5.30859H6.78874",
    stroke: "white",
    strokeWidth: 0.882353,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.48047 13.4297H6.78874",
    stroke: "white",
    strokeWidth: 0.882353,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.48047 7.71484H9.26994",
    stroke: "white",
    strokeWidth: 0.882353,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.48047 10.5703H9.26994",
    stroke: "white",
    strokeWidth: 0.882353,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73048 13.9095L10.0903 12.95C10.1846 12.6985 10.3394 12.4742 10.541 12.2968L14.9819 8.38873C15.4032 8.01798 16.0463 8.06324 16.4116 8.48934C16.7751 8.91345 16.7239 9.55243 16.2975 9.91324L11.7076 13.7969C11.4656 14.0018 11.1691 14.1318 10.8545 14.1711L10.0194 14.2755C9.81609 14.3009 9.65855 14.1013 9.73048 13.9095Z",
    stroke: "white",
    strokeWidth: 0.882353,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewfeedbackWhite);
export default __webpack_public_path__ + "static/media/new feedback_white.c3adfa6184ce18545a1051d912117d65.svg";
export { ForwardRef as ReactComponent };